(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RouteTypeDeleteController',RouteTypeDeleteController);

    RouteTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RouteType'];

    function RouteTypeDeleteController($uibModalInstance, entity, RouteType) {
        var vm = this;

        vm.routeType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RouteType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
